// extracted by mini-css-extract-plugin
module.exports = {"panel-header":"c1vIB","label":"x3dtY","action":"_3IUGF"};